import { registerDecorators as _registerDecorators, registerComponent as _registerComponent, LightningElement } from "lwc";
import _tmpl from "./moreFromThisProvider.html";
import { WireStore } from '@oneappexchange/lwc-wired';
import { getCategoryTagsForTiles, getListingLogo } from '~/modules/helpers/listingHelper';
import { generateBaseUrl } from '~/modules/helpers/routingHelper';
import { Routes } from '~/modules/routes';
import { WireI18n } from '~/modules/stores/i18nStore';
import { DEFAULT_PROVIDER_LISTINGS_TO_DISPLAY, MIN_PROVIDER_LISTINGS_TO_DISPLAY, moreFromProviderStore, MoreFromThisProviderLoadingStatus } from '~/modules/stores/moreFromProviderStore';
import { shuffle } from '~/modules/utilities/arrayUtilities';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
class MoreFromThisProvider extends LightningElement {
  constructor(...args) {
    super(...args);
    this.providerName = '';
    this.
    // @ts-expect-error * Automated Type Error Fix
    i18n = null;
    this.
    // @ts-expect-error * Automated Type Error Fix
    providerState = null;
  }
  get isLoading() {
    return this.providerState.loadingStatus === MoreFromThisProviderLoadingStatus.LOADING;
  }
  get isError() {
    return this.providerState.loadingStatus === MoreFromThisProviderLoadingStatus.ERROR;
  }
  get displayMoreFromThisProvider() {
    return this.providerState?.data?.listings?.length >= MIN_PROVIDER_LISTINGS_TO_DISPLAY && !this.isLoading && !this.isError;
  }
  get providerListings() {
    return shuffle(this.providerState.data?.listings?.map(listing => ({
      oafId: listing.oafId,
      tzId: listing.tzId,
      appExchangeId: listing.appExchangeId,
      id: listing.external_id,
      listingUrl: `${generateBaseUrl()}/${Routes.LISTING}?listingId=${listing.external_id}&channel=recommended`,
      averageRating: listing.reviewsSummary?.averageRating ?? 0,
      reviewsAmount: listing.reviewsSummary?.reviewCount ?? 0,
      publisher: this.providerName,
      listingCategories: getCategoryTagsForTiles(listing),
      image: getListingLogo(listing),
      title: listing.name,
      description: listing.description,
      type: this.getListingType(listing)
    })) ?? [], DEFAULT_PROVIDER_LISTINGS_TO_DISPLAY);
  }
  get props() {
    return {
      title: this.i18n.heading.moreFromThisProvider,
      variant: 'stack',
      format: 'listing',
      type: 'recommended'
    };
  }

  // @ts-expect-error * Automated Type Error Fix
  getListingType(listing) {
    const extension = selectExtensionListing(listing);
    return extension.recordType;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(MoreFromThisProvider, {
  publicProps: {
    providerName: {
      config: 0
    }
  },
  wire: {
    i18n: {
      adapter: WireI18n,
      config: function ($cmp) {
        return {};
      }
    },
    providerState: {
      adapter: WireStore,
      dynamic: [],
      config: function ($cmp) {
        return {
          store: moreFromProviderStore
        };
      }
    }
  }
});
const __lwc_component_class_internal = _registerComponent(MoreFromThisProvider, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;